import React from 'react';
import {
  MEDIUM_COLORS_BY_LABEL,
  METRICS_MAP,
  METRICS_TITLE
} from 'features/command-center/constants';
import { THEME } from 'GlobalStyles';
import { EntityRoutes } from 'routes/constants';
import { colors } from 'UI/res';

import { MetricCell } from './TeamMembersHealth.styled';

export const TEAM_MEMBERS_HEALTH_COLUMNS = [
  {
    name: 'teamName',
    label: 'Team',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CommandCenterOverviewTeam,
          idKey: 'id',
          textKey: 'managerName',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'atRisk',
    label: METRICS_TITLE.atRisk,
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  },
  {
    name: 'behind',
    label: METRICS_TITLE.behind,
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  },
  {
    name: 'onTrack',
    label: METRICS_TITLE.onTrack,
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  },
  {
    name: 'inTraining',
    label: METRICS_TITLE.inTraining,
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  },
  {
    name: 'under3Months',
    label: METRICS_TITLE.under3Months,
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  },
  {
    name: 'headcount',
    label: 'Total',
    options: {
      sort: true,
      display: true,
      renderer: 'healthStatus'
    }
  }
];

export const TEAM_MEMBERS_HEALTH_ORDER_BY_OPTIONS = {
  column: 'teamName',
  direction: 'asc'
};

export const MAP_METRIC_MEDIUM_COLORS = {
  [METRICS_MAP.AtRisk]: MEDIUM_COLORS_BY_LABEL.red,
  [METRICS_MAP.Behind]: MEDIUM_COLORS_BY_LABEL.yellow,
  [METRICS_MAP.OnTrack]: MEDIUM_COLORS_BY_LABEL.green,
  [METRICS_MAP.InTraining]: MEDIUM_COLORS_BY_LABEL.blue,
  [METRICS_MAP.Under3Months]: MEDIUM_COLORS_BY_LABEL.grey,
  [METRICS_MAP.Headcount]: colors.white
};

/**
 * Dark mode heatmap tones per metric, from the lowest to the highest third of values. They follow
 * the palette's tonal steps and all keep at least 4.5:1 contrast with `text.primary` (WCAG AA).
 * The highest warning and grey tones are darker than their palette steps to reach that contrast,
 * and the medium tones sit halfway in contrast between the lowest and highest so all three read
 * apart.
 */
export const DARK_HEATMAP_TONES = {
  [METRICS_MAP.AtRisk]: {
    light: THEME.palette.error.FP100,
    medium: '#643C3E',
    dark: THEME.palette.error.FP300
  },
  [METRICS_MAP.Behind]: {
    light: THEME.palette.warning.FP100,
    medium: '#5E4D2E',
    dark: '#7E6331'
  },
  [METRICS_MAP.OnTrack]: {
    light: THEME.palette.success.FP100,
    medium: '#2C5547',
    dark: THEME.palette.success.FP300
  },
  [METRICS_MAP.InTraining]: {
    light: THEME.palette.info.FP100,
    medium: '#30506A',
    dark: THEME.palette.info.FP300
  },
  [METRICS_MAP.Under3Months]: {
    light: THEME.palette.grey[300],
    medium: '#3B404D',
    dark: '#4B5262'
  }
};

export const DARK_HEATMAP_TEXT_COLOR = THEME.palette.text.primary;

export const teamMembersHealthExtraRenderers = {
  healthStatus: (value, rowData) => {
    const { columnData } = rowData;
    const color = columnData.name === METRICS_MAP.Headcount ? colors.white : value.color;

    return (
      <MetricCell hexColor={color} textColor={value?.textColor}>
        {value?.total ?? 0}
      </MetricCell>
    );
  }
};
